// extracted by mini-css-extract-plugin
export var navBar = "DocsSidebar-module--nav-bar--0f3ab";
export var navFooter = "DocsSidebar-module--nav-footer--9d758";
export var navItem = "DocsSidebar-module--nav-item--80c84";
export var navItemFocus = "DocsSidebar-module--nav-item-focus--e997e";
export var navSubItem = "DocsSidebar-module--nav-sub-item--46851";
export var navSubItemGroup = "DocsSidebar-module--nav-sub-item-group--42b49";
export var navSubItemHeader = "DocsSidebar-module--nav-sub-item-header--597a3";
export var navSubItemHeaderOpen = "DocsSidebar-module--nav-sub-item-header-open--0c927";